import dayjs from '/react4xp/mixins/dayjsConfig';
import { TableColumnsType } from 'antd';
import { localize } from '/react4xp/mixins/helpers';

export const columns = (translations: Record<string, string>, commonTranslations: Record<string, string>): TableColumnsType => [
    {
        title: localize('iin-bin', commonTranslations),
        dataIndex: 'uin',
        key: 'uin',
        render: (item) => (item ? item : '-'),
    },
    {
        title: localize('foreign-recipient-name', translations),
        dataIndex: 'name',
        key: 'name',
        render: (item) => (item ? item : '-'),
    },
    {
        title: localize('foreign-sender-subject-name', translations),
        dataIndex: 'subjectName',
        key: 'subjectName',
        render: (item) => (item ? item : '-'),
    },
    {
        title: localize('foreign-received-amount-in-tenge', translations),
        dataIndex: 'receivedAmount',
        key: 'receivedAmount',
        render: (item) => (item ? item : '-'),
    },
    {
        title: localize('foreign-property-value-in-tenge', translations),
        dataIndex: 'valueOfProperty',
        key: 'valueOfProperty',
        render: (item) => (item ? item : '-'),
    },
    {
        title: localize('foreign-country-name', translations),
        dataIndex: 'countryName',
        key: 'countryName',
        render: (item) => (item ? item : '-'),
    },
];